<template>
  <Modal
    :title="$t('mission.confirmPayModal.title')"
    name="CONFIRM_PAY_MISSION"
    actions
  >
    <template v-slot:body>
      <v-card class="pa-5" color="orange lighten-5" elevation="0">
        <span class="orange--text">
          {{ buildText() }}
        </span>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal('CONFIRM_PAY_MISSION')"
        elevation="0"
        color="grey"
        text
      >
        {{ $t('mission.confirmPayModal.buttons.cancel') }}
      </v-btn>
      <v-btn
        @click="confirm"
        color="primary"
        elevation="0"
        class="ml-5"
        dark
      >
        {{ $t('mission.confirmPayModal.buttons.confirm') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex'
import Modal from '@/components/app/Modal'
import { catalogMonetary } from '@/util/catalog'
export default {
  name: 'ModalMissionPayConfirm',
  components: {
    Modal,
  },
  data() {
    return {
      missionProgress: null,
      mission: null,
      formatMoney: catalogMonetary,
    }
  },
  methods: {
    ...mapActions(['closeModal', 'openModal']),
    openConfirmModal(missionProgress, mission) {
      this.mission = mission
      this.missionProgress = missionProgress
      this.openModal('CONFIRM_PAY_MISSION')
    },
    confirm() {
      this.$emit("confirm", this.missionProgress)
      this.closeModal('CONFIRM_PAY_MISSION')
    },
    buildText() {
      return this.$t('mission.confirmPayModal.text', {price: this.formatMoney(this.mission.price), email: this.missionProgress.host_email}) 
    }
  },
}
</script>
